/**
 * Photo carousel for the 1K · Photo carousel section.
 * The track scrolls natively (swipe, trackpad, keyboard); the arrow buttons move it by one
 * screenful and switch off at either end.
 */
class KpGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ref="track"]');
    this.prev = this.querySelector('[data-ref="prev"]');
    this.next = this.querySelector('[data-ref="next"]');
    if (!this.track) return;

    this.abort = new AbortController();
    const { signal } = this.abort;

    this.prev?.addEventListener('click', () => this.move(-1), { signal });
    this.next?.addEventListener('click', () => this.move(1), { signal });
    this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
    window.addEventListener('resize', () => this.queueUpdate(), { signal });
    this.updateArrows();
  }

  disconnectedCallback() {
    this.abort?.abort();
    cancelAnimationFrame(this.frame);
  }

  /** @param {number} direction -1 for back, 1 for forward */
  move(direction) {
    const item = this.track.querySelector('.kp-gallery__item');
    const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || '0') : 300;
    // Move by the number of whole photos that fit on screen
    const perView = Math.max(1, Math.floor(this.track.clientWidth / step));
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    this.track.scrollBy({ left: direction * step * perView, behavior });
  }

  queueUpdate() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.updateArrows());
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
  }
}

if (!customElements.get('kp-gallery')) {
  customElements.define('kp-gallery', KpGallery);
}
